// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/cloud-feature-identification.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/cloud-feature-identification/cloud-feature-identification.js';

mount([g0]);
